<template>
    <dashboard-container>
        <dashboard-section header="Your Team">

            <template v-slot:additional>
                <router-link :to="{ name: 'CreateInvite', params: { ...$route.params }, query: { ...$route.query }}" class="underline transition duration-150 text-secondary dark:text-secondary-300 hover:text-secondary-300 focus:outline-none focus:shadow-outline rounded-sm">+ Invite new member</router-link>
            </template>

            <div class="flex flex-col space-y-4" v-if="currentProject">

                <dashboard-card v-for="member in teamMembers" :key="member.id">
                    <div class="w-full flex items-center justify-between">
                        <div class="flex items-center space-x-4">
                            <avatar :src="member.profilePictureUrl" :name="member.name || member.email"/>

                            <typography variant="p" class="font-semibold">{{ member.name || member.email }}</typography>
                        </div>

                        <div class="flex items-center space-x-4">
                            <span class="text-xs py-2 px-3 font-semibold leading-none rounded-full bg-primary bg-opacity-10 text-primary uppercase">{{ member.role }}</span>
                        </div>
                    </div>
                </dashboard-card>

            </div>
            
        </dashboard-section>

        <dashboard-section header="Pending Invites">

            <div class="flex flex-col space-y-4" v-if="currentProject">

                <dashboard-card v-for="invite in pendingInvites" :key="invite.code">
                    <div class="w-full flex items-center justify-between">
                        <div class="flex items-center space-x-4">
                            <typography variant="p" class="font-semibold">{{ invite.email }}</typography>
                        </div>

                        <div class="flex items-center space-x-4">
                            <span class="text-xs py-2 px-3 font-semibold leading-none rounded-full bg-gray-800 bg-opacity-10 text-gray-600 uppercase">{{ invite.role }}</span>

                            <button @click="inviteToDelete = invite.email"
                        
                            :disabled="isSubmitting"
                            class="p-1 rounded-full focus:outline-none focus:shadow-outline">
                                <icon-svg icon="delete" class="w-4 text-gray-600"/>

                                <modal @action="cancelInvite" @close="inviteToDelete = null" 
                                :open="inviteToDelete === invite.email" cta="Confirm Delete" title="Are you sure?" error>
                                    <p>We'll retract this team invite.</p>
                                </modal>
                            </button>

                        </div>
                    </div>
                </dashboard-card>

                <typography variant="p" class="text-gray-600" v-show="!pendingInvites.length">You have no pending invites.</typography>

            </div>
            
        </dashboard-section>
    
    </dashboard-container>
</template>

<script>
import { LayoutComponents } from '@/modules/Dashboard/components'
import { currentProject, error, loading } from '@/mixins'
import { cancelInvite } from "@/graphql/mutations";

export default {
    name: "TeamPage",
    metaInfo: {
      title: 'Team',
    },
    data () {
        return {
            isSubmitting: false,
            inviteToDelete: null
        }
    },
    mixins: [ LayoutComponents, currentProject, error, loading ],
    methods: {
        async cancelInvite() {
            if (this.isSubmitting) {
                return;
            }

            this.isSubmitting = true;

            try {
                this.$root.$emit('loading', true);

                await this.$apollo.mutate({
                    mutation: cancelInvite,
                    variables: {
                        input: {
                            email: this.inviteToDelete,
                            projectId: this.currentProject.id
                        }
                    },
                });

            } catch (error) {
                this.handleError(error);
            }

            this.$root.$emit('loading', false);

            this.isSubmitting = false;
            this.inviteToDelete = null;
        }
    }
}
</script>